export const alignedInfoContent = [
  {
    caption: 'In der Nähe',
    headline: 'Kein Auto notwendig!',
    content: `Vereinfache deinen Alltag ohne lange Anfahrtswege 
    dank der Radarfunktion von Jobbrn - Finde einfach und schnell potenzielle Helfer 
    und Aufgaben in deiner unmittelbaren Umgebung. Spare Zeit⏰ und Kosten für die 
    Anfahrt🚗💰 und tue so gleichzeitig ganz nebenbei etwas für die Umwelt!🌍❤️`,
    ctaText: 'cta Text',
    animation: require('assets/radar_lottie.json'),
  },
  {
    caption: 'Reagiere direkt',
    headline: 'Integrierter Chat',
    content: `Verbinden dich mit Menschen in deiner Umgebung dank dem integrierten Chat.
    Reagiere auf Anfragen oder biete deine Hilfe an👋 - einfach und bequem von deinem Smartphone aus.📱`,
    ctaText: 'cta Text',
    animation: require('assets/chat_lottie.json'),
  },
];

export const splitInfoContent = [
  {
    headline: 'Einfach 💡',
    content:
      'Du suchst jemanden in deiner Nähe der schnell eine Aufgabe übernehmen kann?',
  },
  {
    headline: 'Schnell 🚀',
    content:
      'Sobald du einen Auftrag oder ein Angebot erstellst, werden alle Jobbrn Nutzer in deiner Umgebung informiert!',
  },
  {
    headline: 'Direkt 💬',
    content:
      'Trete mit potentiellen Helfern oder Auftraggebern über den App eigenen Chat in Kontakt!',
  },
];
